<template>
  <div>
    <b-overlay
      :show="loading"
      opacity="0.7"
      spinner-variant="primary"
    >
      <b-navbar toggleable="lg" type="light" variant="warning" class="navbar">
        <b-navbar-nav>
          <b-nav-item v-b-modal.setting-modal>
            <b-icon-gear></b-icon-gear>
          </b-nav-item>
          <b-nav-item
            class="nav-block"
            v-if="lNo !== '无课程'"
          >
            <div class="nav-block-item" @click="handlePrev">
              <b-icon-chevron-left></b-icon-chevron-left>
            </div>
            <div class="nav-block-item">
              第 {{ lNo }} 课
            </div>
            <div class="nav-block-item" @click="handleNext">
              <b-icon-chevron-right></b-icon-chevron-right>
            </div>
          </b-nav-item>
          <b-nav-item @click="getBatchData">
            <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
          </b-nav-item>
        </b-navbar-nav>
      </b-navbar>

      <b-container>
        <b-row class="mt-2 justify-content-md-center">
          <b-col col lg="6">
            <b-progress
              :value="lessonProgress"
              height="12px"
              variant="secondary"
              max="100"
              show-progress
            ></b-progress>
          </b-col>
        </b-row>

        <!--   memo mode   -->
        <div v-if="!quizMode">
          <b-row class="mt-4 justify-content-md-center">
            <b-col col lg="6">
              <b-card>
                <b-row v-if="oldStyleMode && oldType === 'ugr'">
                  <b-col class="old-mgl-text-wrapper" cols="4">
                    <p
                      class="old-mgl-text"
                      style="font-family: Onon Sonin MGL !important;"
                    >
                      {{ oldWord }}
                    </p>
                  </b-col>
                  <b-col class="old-mgl-expl-wrapper" cols="8">
                    <div class="expl-text">
                      {{ expl }}
                    </div>
                  </b-col>
                </b-row>

                <b-row v-if="oldStyleMode && oldType === 'arb'">
                  <b-col class="text-center">
                    <p class="main-text" style="font-family: Noto Sans ARB !important;">
                      {{ oldWord }}
                    </p>
                    <div class="expl-text">
                      {{ expl }}
                    </div>
                  </b-col>
                </b-row>

                <b-row v-if="!oldStyleMode">
                  <b-col class="text-center">
                    <p class="main-text">
                      {{ newWord }}
                    </p>
                    <div class="expl-text">
                      {{ expl }}
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="justify-content-md-center">
            <b-col col lg="6">
              <audio
                id="player"
                :src="audio"
                controls
                autoplay
              ></audio>
            </b-col>
          </b-row>

          <div class="img-outer-wrapper">
            <b-row class="justify-content-md-center">
              <b-col col lg="6">
                <div
                  class="img-btn-wrapper"
                  @click="handleUploaderSwitchClick"
                  v-if="!imgUploaderStatus"
                >
                  <b-button variant="outline-success">
                    <b-icon-card-image></b-icon-card-image>
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <b-row class="mt-2 justify-content-md-center" v-if="imgData">
              <b-col col lg="6">
                <div
                  class="img-wrapper"
                  :style="`background-image: url('${imgData}')`"
                ></div>
              </b-col>
            </b-row>

            <b-row class="mt-2 justify-content-md-center" v-if="imgUploaderStatus">
              <b-col col lg="3">
                <input
                  type="file"
                  class="uploader-anchor"
                  ref="uploader"
                  @change="handleUploaderChange"
                />
                <div class="img-uploader" @click="handleUploaderClick">
                  <div class="img-uploader-btn-wrapper">
                    <b-icon-card-image></b-icon-card-image>
                    <div>点击上传图片</div>
                  </div>
                </div>
              </b-col>
              <b-col col lg="3">
                <b-form-textarea
                  id="textarea"
                  placeholder="粘贴图片到此处（仅电脑端可用）"
                  no-resize
                  @paste="handleTextDataPaste"
                ></b-form-textarea>
              </b-col>
            </b-row>
          </div>

          <b-row class="mt-4 justify-content-md-center">
            <b-col col lg="6">
              <b-button
                variant="primary"
                block
                size="lg"
                @click="handleMemoClick"
              >
                <b-icon-lightning-charge-fill></b-icon-lightning-charge-fill>
              </b-button>
            </b-col>
          </b-row>
        </div>

        <!--  quiz mode    -->
        <div v-if="quizMode">
          <b-row class="mt-4 justify-content-md-center">
            <b-col col lg="6">
              <b-row
                class="justify-content-center"
                v-if="oldStyleMode && oldType === 'ugr'"
              >
                <b-col class="old-mgl-text-wrapper" cols="12">
                  <p
                    style="font-size: 34px;font-family: Onon Sonin MGL !important;"
                  >
                    {{ oldWord }}
                  </p>
                </b-col>
              </b-row>

              <b-row v-if="oldStyleMode && oldType === 'arb'">
                <b-col class="text-center">
                  <p class="main-text" style="font-family: Noto Sans ARB !important;">
                    {{ oldWord }}
                  </p>
                </b-col>
              </b-row>

              <b-row v-if="!oldStyleMode">
                <b-col class="text-center">
                  <p class="main-text">
                    {{ newWord }}
                  </p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="justify-content-md-center">
            <b-col col lg="6">
              <audio
                id="player"
                :src="audio"
                controls
                autoplay
              ></audio>
            </b-col>
          </b-row>

          <div>
            <b-row
                class="mt-2 justify-content-md-center"
                v-for="(item, opIdx) in options"
                :key="item.id"
            >
              <b-col col lg="6">
                <b-card
                  :bg-variant="showResult === opIdx ? (item.right ? 'success' : 'danger') : ''"
                  :text-variant="showResult === opIdx ? 'white' : 'dark'"
                  @click="() => handleQuizOptionClick(item, opIdx)"
                >
                  <div class="expl-text">
                    {{item.expl}}
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>

        <b-row class="mt-4 justify-content-md-center">
          <b-col col lg="6">
            <b-progress
              :value="batchProgress"
              :variant="batchProgress === 100 ? 'success' : 'primary'"
              max="100"
              animated
            ></b-progress>
          </b-col>
        </b-row>

        <b-row class="mt-5 book-name">
          <b-col>
            {{ bookName }}
          </b-col>
        </b-row>
      </b-container>

      <b-modal
        id="setting-modal"
        title="设置"
        centered
        hide-footer
      >
        <b-row>
          <b-col>
            <b-form-checkbox
              switch
              size="lg"
              v-model="oldStyleMode"
              @change="handleTextStyleChange"
              :disabled="oldType === ''"
            >
              传统文字
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox
              switch
              size="lg"
              v-model="reviewMode"
              @change="handleModeChange"
            >
              复习模式
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox
              switch
              size="lg"
              v-model="quizMode"
              @change="handleQuizChange"
            >
              测验模式
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col class="justify-md-content-center">
            <b-button @click="handleClearHistory">
              清除数据
            </b-button>
          </b-col>
          <b-col>
            <b-input-group prepend="课号">
              <b-form-select
                id="lno-select"
                :value="lNo"
                :options="lList"
                @change="handleLNoChange"
              ></b-form-select>
            </b-input-group>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        id="result-modal"
        title="测验结果"
        centered
        ok-title="新来一组"
        cancel-title="再做一次"
        @ok="handleResultOk"
        @cancel="handleResultCancel"
      >
        <b-row>
          <b-col class="mb-2 text-center">
            得分: <span style="font-size: 18px;font-weight: bold">{{score}}</span>
          </b-col>
        </b-row>
        <b-row v-if="score < 100">
          <b-col class="mb-2 text-center">
            错误的单词:
          </b-col>
        </b-row>
        <b-row v-for="wrongItem in wrongWords" :key="wrongItem.id">
          <b-col col lg="6" class="text-right" v-if="!oldStyleMode">
            <p style="font-family: Arial !important;">
              {{wrongItem.word}}
            </p>
          </b-col>
          <b-col col lg="6" class="text-right" v-if="oldStyleMode && oldType === 'ugr'">
            <p
              style="font-size: 18px;font-family: Onon Sonin MGL !important;"
            >
              {{wrongItem.oldWord}}
            </p>
          </b-col>
          <b-col col lg="6" class="text-right" v-if="oldStyleMode && oldType === 'arb'">
            <p
              class="text-right" style="font-family: Noto Sans ARB !important;"
            >
              {{wrongItem.oldWord}}
            </p>
          </b-col>
          <b-col col lg="6" class="text-left">
            {{wrongItem.expl}}
          </b-col>
        </b-row>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import ld from 'lodash'
import {
  getBasicInfo,
  setSetting,
  getBatchWords,
  setProgress,
  getLessonProgress,
  getWordImgInfo,
  setWordImg,
  clearHistory,
} from '@/utils/storage'
import { getBase64 } from '@/utils/utils'

const BATCH_SIZE = 12
const S_STYLE_ON = 'old'
const S_STYLE_OFF = 'new'
const S_REVIEW_ON = 'review'
const S_REVIEW_OFF = 'default'
const Q_SIZE = 4 // 题目选项个数，this.data的长度必须大于这个数

export default {
  name: 'IndexPage',

  data: () => ({
    isOld: false,
    lList: [],
    lNo: '',
    oldStyleMode: false, 
    reviewMode: false,
    quizMode: false,
    oldType: '',
    baseUrl: '',
    bookName: '',

    newWord: '',
    oldWord: '',
    expl: '',
    audio: '',
    batchProgress: 0,
    lessonProgress: 0,

    words : [],
    memoed: [],
    last: null,
    wordId: null,

    questData: {}, // 复习模式的题目数据
    options: [], // 题目的选项
    showResult: -1, // 在按钮上显示作答结果
    wrongWords: [], // 选错的单词
    score: 0, // 最终得分

    imgInfo: null,
    loading: false,

    imgData: null, // 用于解析base64图片
    imgUploaderStatus: false,
  }),

  watch: {
    async lNo(res) {
      await setSetting('s_lno', res)
      await this.getBatchData()
    },
    reviewMode() {
      this.getBatchData()
    },
  },

  async created() {
    this.loading = true

    const ret = await this.initBasicInfo()
    if (ret) {
      await this.initData()
    } else {
      this.$bvModal.msgBoxOk('请先选择单词书再进行背诵', {
        title: '提示',
        size: 'sm',
        buttonSize: 'sm',
        okTitle: '好的',
        okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true,
      }).then(() => {
        this.jumpToWordBase()
      })
    }

    this.loading = false
  },

  methods: {
    async initBasicInfo() {
      const basicInfo = await getBasicInfo()
      const { lList, lNo, oldType, textStyle, mode, quiz, baseUrl, bookName } = basicInfo
      
      this.lList = lList
      this.lNo = lNo
      this.oldStyleMode = textStyle === S_STYLE_ON ? true : false
      this.reviewMode = mode === S_REVIEW_ON ? true : false
      this.quizMode = quiz
      this.oldType = oldType
      this.baseUrl = baseUrl
      this.bookName = bookName

      if (lNo === '无课程') {
        return false
      } else {
        return true
      }
    },
    async initData() {
      await this.getBatchData()
      await this.initWordImgData()
    },
    async initWordImgData() {
      this.imgInfo = await getWordImgInfo()
    },
    initQuizData() {
      const tmpQuestData = {}
      this.words.forEach((wordItem) => {
        wordItem.right = true

        const options = [JSON.parse(JSON.stringify(wordItem))]
        const usedIds = [wordItem.id]
        while (options.length < Q_SIZE && this.words.length >= Q_SIZE) {
          const randIdx = Math.floor(Math.random() * this.words.length)
          const randWordItem = JSON.parse(JSON.stringify(this.words[randIdx]))
          if (randWordItem.id !== wordItem.id && !usedIds.includes(randWordItem.id)) {
            randWordItem.right = false
            options.push(randWordItem)
            usedIds.push(randWordItem.id)
          }
        }
        tmpQuestData[wordItem.word] = options.sort(() => Math.random() - 0.5)
      })
      this.questData = tmpQuestData
      this.wrongWords = []
      this.score = 0
    },
    async getBatchData() {
      if (this.lNo !== '' && this.lNo !== '无课程') {
        const { lNo, reviewMode } = this
        this.words = await getBatchWords(BATCH_SIZE, lNo, reviewMode)
        this.memoed = []

        if (this.quizMode) {
          this.initQuizData()
          this.quest()
        } else {
          this.memo()
        }
      }
    },
    async handleModeChange(res) {
      if (res) {
        await setSetting('s_mode', S_REVIEW_ON)
      } else {
        await setSetting('s_mode', S_REVIEW_OFF)
      }
    },
    async handleQuizChange(res) {
      if (res) {
        await setSetting('s_quiz', true)
        this.initQuizData()
        this.options = this.questData[this.newWord]
      } else {
        await setSetting('s_quiz', false)
      }
    },
    async handleTextStyleChange(res) {
      if (res) {
        await setSetting('s_text', S_STYLE_ON)
      } else {
        await setSetting('s_text', S_STYLE_OFF)
      }
    },
    async handleLNoChange(res) {
      this.lNo = res
    },
    handleUploaderSwitchClick() {
      this.imgUploaderStatus = true
      this.imgData = null
    },
    handleUploaderClick() {
      this.$refs.uploader.click()
    },
    handleUploaderChange(res) {
      const files = res.target.files
      if (files.length > 0) {
        const file = files[files.length - 1]
        getBase64(file, this.processImg)
      }
    },
    handleTextDataPaste(e) {
      if (e.clipboardData && e.clipboardData.items) {
        const { items } = e.clipboardData

        let status = true
        for (let i = 0; status && (i < items.length); i += 1) {

          const item = items[i]

          if (item.kind === "file") {
              const file = item.getAsFile()

              getBase64(file, this.processImg)

              status = false
          }
        }
      }
    },
    handleMemoClick() {
      this.last = this.wordId
      this.memo()
    },
    handleQuizOptionClick(wordItem, opIdx) {
      if (!wordItem.right && this.last !== this.wordId) {
        this.options.forEach((opItem) => {
          if (opItem.right) {
            this.wrongWords.push(opItem)
          }
        })
      }

      this.last = this.wordId
      this.showResult = opIdx
      setTimeout(() => {
        if (this.batchProgress < 100) {
          this.quest()
        } else {
          this.genQuizResult()
        }
        this.showResult = -1
      }, 300)
    },
    genQuizResult() {
      this.$bvModal.show('result-modal')
      this.score = Math.floor(100 * (this.words.length - this.wrongWords.length) / this.words.length)
    },
    handleResultOk() {
      this.getBatchData()
    },
    handleResultCancel() {
      this.memoed = []
      this.wrongWords = []
      this.batchProgress = 0
      this.quest()
    },
    handlePrev() {
      const intLNo = parseInt(this.lNo)

      if (intLNo > 1) {
        this.lNo = `${intLNo - 1}`
      }
    },
    handleNext() {
      const intLNo = parseInt(this.lNo)

      if (intLNo < this.lList.length) {
        this.lNo = `${intLNo + 1}`
      }
    },
    handleClearHistory() {
      this.$bvModal.hide('setting-modal')
      this.$bvModal.msgBoxConfirm(
        '你是否确定要清除本书的进度数据？',
        {
          title: '清除历史数据',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: '确定',
          cancelTitle: '取消',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      ).then(async (val) => {
        if (val) {
          await clearHistory()
          await this.initData()
        }
      })
    },
    async processImg(data) {
      this.imgData = data
      this.imgUploaderStatus = false

      await setWordImg(this.wordId, data)
      await this.initWordImgData()
    },
    genNextWord(unique=false) {
      const { words } = this
      let idx = Math.floor(Math.random() * BATCH_SIZE)

      let needStatus// 符合不同要求的状态变量
      // 分别处理
      if (unique) { // 防止已经做过的题的再次出现
        needStatus = this.memoed.includes(words[idx].id)
      } else { // 防止连续两个词是重复的
        needStatus = this.wordId === words[idx].id
      }
      while (words.length > 0 && needStatus) {
        idx = Math.floor(Math.random() * BATCH_SIZE)

        if (unique) { // 防止已经做过的题的再次出现
          needStatus = this.memoed.includes(words[idx].id)
        } else { // 防止连续两个词是重复的
          needStatus = this.wordId === words[idx].id
        }
      }

      const { id, word, oldWord, expl, audio } = words[idx]

      this.newWord = word
      this.oldWord = oldWord
      this.expl = expl
      this.audio =  this.baseUrl + audio
      this.wordId = id
      this.imgData = this.imgInfo ? this.imgInfo[id] : null

      return id
    },
    memo() {
      const wordId = this.genNextWord()

      this.updateBookProgress(wordId)
      this.updateLessonProgress()
      this.updateBatchProgress(wordId)
    },
    quest() {
      const wordId = this.genNextWord(true)
      this.options = this.questData[this.newWord]

      this.updateBookProgress(wordId)
      this.updateLessonProgress()
      this.updateBatchProgress(wordId)
    },
    jumpToWordBase() {
      this.$router.push('/word-base')
    },
    async updateBookProgress(id) {
      await setProgress(id)
    },
    async updateLessonProgress() {
      const { lNo, reviewMode } = this
      this.lessonProgress = await getLessonProgress(lNo, reviewMode)
    },
    updateBatchProgress(id) {
      this.memoed.push(id)
      this.memoed = ld.uniq(this.memoed)

      const len = this.words.length
      const memoCount = this.memoed.length

      this.batchProgress = 100 * (memoCount / len)
    },
  },
}
</script>

<style scoped>
.navbar-nav {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.nav-block-item {
  display: inline-block;
  margin: 0 25px;
}

.navbar-light .navbar-nav .nav-link {
  color: #000;
}

.old-mgl-text {
  font-size: 34px;
  writing-mode: vertical-lr;
  text-orientation: sideways;
}

.main-text{
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 30px;
}

.expl-text {
  font-size: 18px;
  text-align: center;
}

.old-mgl-text-wrapper {
  display: flex;
  justify-content: center;
}
.old-mgl-expl-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#player {
  width: 100%;
  margin-top: 10px;
  background-color: #f1f3f4;
  position: relative;
  border-radius: 4px;
  border: 1px #ddd solid;
}

.img-outer-wrapper {
  position: relative;
  min-height: 40px;
}

.uploader-anchor {
  display: none;
}

.img-uploader {
  display: flex;
  height: 80px;
  border: 1px #555 dashed;
  border-radius: 4px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
}

.img-uploader-btn-wrapper {
  text-align: center;
  color: #555;
}

#textarea {
  height: 80px;
}

.img-btn-wrapper {
  position: absolute;
  top: 13px;
  right: 20px;
  z-index: 999;
}

.img-wrapper {
  width: 100%;
  height: 24vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.book-name {
  text-align: center;
  color: #ccc;
  font-size: 18px;
}
</style>
